export const paths = {
    ACCOUNT: 'account',
    ADMIN: 'admin',
    API_AWAY: 'api/away',
    API_LEAVE: 'api/leave',
    API_ACCOUNT_GAMES: 'api/account/games',
    API_ACCOUNT_LOGIN: 'api/account/login',
    API_ACCOUNT_LOGOUT: 'api/account/logout',
    API_ACCOUNT_RECENT: 'api/account/recent',
    API_ACCOUNT_REGISTER: 'api/account/register',
    API_CLONEABLEGAME: 'api/cloneablegame',
    API_CREATEGAME: 'api/creategame',
    API_GAME: 'api/game',
    API_GAME_HISTORY: 'api/game/history',
    API_GAME_LOGS: 'api/game/logs',
    API_GAMES: 'api/games',
    API_HEAP_SNAPSHOT: 'api/heapsnapshot',
    API_IPS: 'api/ips',
    API_METRICS: 'api/metrics',
    API_LOBBY: 'api/lobby',
    API_LOBBY_JOIN: 'api/lobby/join',
    API_LOGOUT: 'api/logout',
    API_PLAYER: 'api/player',
    API_PLAYER_NAME: 'api/player/name',
    API_PROFILE: 'api/profile',
    API_RANDOM_MAP: 'api/randommap',
    API_SPECTATOR: 'api/spectator',
    API_STATS: 'api/stats',
    API_WAITING_FOR: 'api/waitingfor',
    AUTH_DISCORD_CALLBACK: 'auth/discord/callback',
    AUTOPASS: 'autopass',
    CARDS: 'cards',
    END_GAME_LOG: 'end_game_log',
    GAME: 'game',
    GAMES_OVERVIEW: 'games-overview',
    HELP: 'help',
    JOIN: 'join',
    LOAD: 'load',
    LOAD_GAME: 'load_game',
    LOGIN: 'login',
    MY_GAMES: 'my-games',
    NEW_GAME: 'new-game',
    PLAYER: 'player',
    PLAYER_INPUT: 'player/input',
    RESET: 'reset',
    SPECTATOR: 'spectator',
    THE_END: 'the-end',
};
